// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (c) 2019-2022 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.tool-palette .palette-body .group-header {
    background: var(--theia-editorHoverWidget-statusBarBackground);
}

.bpmn-grid-line {
    stroke-width: 0.5;
    stroke: var(--theia-titleBar-activeBackground);
}

.helper-line {
    stroke: var(--theia-focusBorder);
    stroke-width: 0.5;
}

.icon path {
    stroke-width: 0;
    fill: #f0f3f8;
}

.icon .icon-background {
    fill: transparent;
}

/* BPMN Elements */
.task>.sprotty-node {


    fill: #84a1bd;
    stroke-width: 1px;
    stroke: var(--theia-foreground);
}

.event.startEvent>circle {
    fill: #57A14C;
}

.event.endEvent>circle {
    fill: #BE5961;
    stroke-width: 3px;
    stroke: #922828;
}

.event.intermediateCatchEvent>circle {
    fill: #b6c7d9;
    stroke: var(--theia-foreground);
}

.event.intermediateThrowEvent>circle {
    fill: #b6c7d9;
    stroke: var(--theia-foreground);
}

.event.boundaryEvent>circle {
    fill: #627ea5;
    opacity: 80%;
    stroke-width: 1;
    stroke: #354152a8
}

.gateway>polygon {
    fill: #C39D5C;
}

.dataObject>.sprotty-node {
    opacity: 80%;
    stroke: var(--theia-focusBorder);
    outline-color: var(--theia-editor-foreground);
    outline-style: solid;
    outline-width: 2px;
    fill: #82848a;
}

.dataStoreReference>.sprotty-node {
    opacity: 80%;
    fill: transparent;
}

.dataStoreReference>.sprotty-icon {
    stroke-width: 2;
}

.message>.sprotty-node {
    opacity: 80%;
    stroke: var(--theia-focusBorder);
    outline-color: var(--theia-editor-foreground);
    outline-style: solid;
    outline-width: 2px;
    fill: #6083a6;
}

.message>polyline {
    stroke: var(--theia-editor-foreground);
    stroke-width: 2;
    fill: none;
}

.textAnnotation>.sprotty-node {
    opacity: 20%;
    fill: #82848a;
}

.textAnnotation>polyline {
    stroke: #57A14C;
    stroke-width: 2;
    fill: none;
}

.textAnnotation .bpmn-text-node text {
    fill: #447c3c;
    text-anchor: start;
    white-space: pre;
    font-family: 'Courier New', Courier, monospace;
}

.task .bpmn-text-node text {
    fill: #f5f9ff;
    text-anchor: middle;
}

.task .extension text {
    fill: #f5f9ff;
    font-size: 7pt;
    text-anchor: start;
}

.task .icon path {
    stroke-width: 0;
    fill: #f5f9ff;
}

.BPMNLabel>.sprotty-node {
    fill: transparent;
}

.BPMNLabel>.sprotty-label.heading {
    fill: var(--theia-titleBar-activeForeground);
}

.BPMNLabel>.sprotty-node.mouseover {
    fill: var(--theia-sideBar-background);
}

.BPMNLabel .bpmn-text-node text {
    fill: var(--theia-titleBar-activeForeground);
    text-anchor: middle;
}

.label-edit textarea {
    font-size: 1em !important;
    text-align: center;
    margin: 1px;
}

/*** Pool and Lanes **/
.pool>.sprotty-node {
    fill: var(--theia-sideBar-background);
    pointer-events: none;
    fill-opacity: 70%;
    stroke: var(--theia-focusBorder);
    stroke-width: 2;
}

.pool>.sprotty-node.mouseover {
    stroke: var(--theia-focusBorder);
    opacity: 100%;
}

.pool>.pool_header {
    fill: var(--theia-titleBar-activeBackground);
    stroke: var(--theia-focusBorder);
    stroke-width: 2;
}

.pool>.pool_header:hover,
.lane>.lane_header:hover {
    opacity: 70%;
}

.pool .pool_header text {
    font-weight: normal;
    font-size: 0.7em;
    fill: var(--theia-titleBar-activeForeground);
}

.lane>.lane_header {
    fill: var(--theia-titleBar-activeBackground);
}

.lane .lane_header text {
    font-weight: normal;
    font-size: 0.7em;
    fill: var(--theia-titleBar-activeForeground);
}

.lane>.sprotty-node {
    fill: none;
}

.lane-divider {
    cursor: row-resize;
}

.lane-divider>polyline {
    stroke: var(--theia-focusBorder);
    stroke-width: 2;
    fill: none;
}

.lane-divider rect {
    fill: transparent;
}

.sequenceFlow .default-symbol {
    stroke-width: 3;
}

/* BPMN Edges */
.bpmnedge>.sprotty-label {
    fill: var(--theia-titleBar-activeForeground);
    text-align: center;
}

.sprotty-edge.messageFlow .line {
    stroke-dasharray: 6, 4;
}

.sprotty-edge.association .line {
    stroke-dasharray: 4, 4;
}

.sprotty-comp {
    stroke: transparent;
    fill: transparent;
}


/* Extension Imixs-Workflow (draft) */
.intermediateCatchEvent.bpmnextension-imixs>circle {
    fill: #6f8dab;
    stroke-width: 2px;
    stroke: #d48729;
}

.intermediateCatchEvent.bpmnextension-imixs .icon path {
    stroke-width: 0;
    fill: #f0f3f8;
}

.task.bpmnextension-imixs>.sprotty-node {
    fill: #425C81;
    stroke-width: 2px;
    stroke: #d48729;
}

.task.bpmnextension-imixs .bpmn-text-node text {
    fill: #f0f3f8;
    text-anchor: middle;
}

.task.bpmnextension-imixs .extension text {
    fill: #f0f3f8;
    font-size: 7pt;
    text-anchor: start;
}`, "",{"version":3,"sources":["webpack://./../open-bpmn-glsp/css/diagram.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;IACI,8DAA8D;AAClE;;AAEA;IACI,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;;;IAGI,aAAa;IACb,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,6CAA6C;IAC7C,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,6CAA6C;IAC7C,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,qCAAqC;IACrC,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;;AAGA,qCAAqC;AACrC;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB","sourcesContent":["/********************************************************************************\n * Copyright (c) 2019-2022 EclipseSource and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.tool-palette .palette-body .group-header {\n    background: var(--theia-editorHoverWidget-statusBarBackground);\n}\n\n.bpmn-grid-line {\n    stroke-width: 0.5;\n    stroke: var(--theia-titleBar-activeBackground);\n}\n\n.helper-line {\n    stroke: var(--theia-focusBorder);\n    stroke-width: 0.5;\n}\n\n.icon path {\n    stroke-width: 0;\n    fill: #f0f3f8;\n}\n\n.icon .icon-background {\n    fill: transparent;\n}\n\n/* BPMN Elements */\n.task>.sprotty-node {\n\n\n    fill: #84a1bd;\n    stroke-width: 1px;\n    stroke: var(--theia-foreground);\n}\n\n.event.startEvent>circle {\n    fill: #57A14C;\n}\n\n.event.endEvent>circle {\n    fill: #BE5961;\n    stroke-width: 3px;\n    stroke: #922828;\n}\n\n.event.intermediateCatchEvent>circle {\n    fill: #b6c7d9;\n    stroke: var(--theia-foreground);\n}\n\n.event.intermediateThrowEvent>circle {\n    fill: #b6c7d9;\n    stroke: var(--theia-foreground);\n}\n\n.event.boundaryEvent>circle {\n    fill: #627ea5;\n    opacity: 80%;\n    stroke-width: 1;\n    stroke: #354152a8\n}\n\n.gateway>polygon {\n    fill: #C39D5C;\n}\n\n.dataObject>.sprotty-node {\n    opacity: 80%;\n    stroke: var(--theia-focusBorder);\n    outline-color: var(--theia-editor-foreground);\n    outline-style: solid;\n    outline-width: 2px;\n    fill: #82848a;\n}\n\n.dataStoreReference>.sprotty-node {\n    opacity: 80%;\n    fill: transparent;\n}\n\n.dataStoreReference>.sprotty-icon {\n    stroke-width: 2;\n}\n\n.message>.sprotty-node {\n    opacity: 80%;\n    stroke: var(--theia-focusBorder);\n    outline-color: var(--theia-editor-foreground);\n    outline-style: solid;\n    outline-width: 2px;\n    fill: #6083a6;\n}\n\n.message>polyline {\n    stroke: var(--theia-editor-foreground);\n    stroke-width: 2;\n    fill: none;\n}\n\n.textAnnotation>.sprotty-node {\n    opacity: 20%;\n    fill: #82848a;\n}\n\n.textAnnotation>polyline {\n    stroke: #57A14C;\n    stroke-width: 2;\n    fill: none;\n}\n\n.textAnnotation .bpmn-text-node text {\n    fill: #447c3c;\n    text-anchor: start;\n    white-space: pre;\n    font-family: 'Courier New', Courier, monospace;\n}\n\n.task .bpmn-text-node text {\n    fill: #f5f9ff;\n    text-anchor: middle;\n}\n\n.task .extension text {\n    fill: #f5f9ff;\n    font-size: 7pt;\n    text-anchor: start;\n}\n\n.task .icon path {\n    stroke-width: 0;\n    fill: #f5f9ff;\n}\n\n.BPMNLabel>.sprotty-node {\n    fill: transparent;\n}\n\n.BPMNLabel>.sprotty-label.heading {\n    fill: var(--theia-titleBar-activeForeground);\n}\n\n.BPMNLabel>.sprotty-node.mouseover {\n    fill: var(--theia-sideBar-background);\n}\n\n.BPMNLabel .bpmn-text-node text {\n    fill: var(--theia-titleBar-activeForeground);\n    text-anchor: middle;\n}\n\n.label-edit textarea {\n    font-size: 1em !important;\n    text-align: center;\n    margin: 1px;\n}\n\n/*** Pool and Lanes **/\n.pool>.sprotty-node {\n    fill: var(--theia-sideBar-background);\n    pointer-events: none;\n    fill-opacity: 70%;\n    stroke: var(--theia-focusBorder);\n    stroke-width: 2;\n}\n\n.pool>.sprotty-node.mouseover {\n    stroke: var(--theia-focusBorder);\n    opacity: 100%;\n}\n\n.pool>.pool_header {\n    fill: var(--theia-titleBar-activeBackground);\n    stroke: var(--theia-focusBorder);\n    stroke-width: 2;\n}\n\n.pool>.pool_header:hover,\n.lane>.lane_header:hover {\n    opacity: 70%;\n}\n\n.pool .pool_header text {\n    font-weight: normal;\n    font-size: 0.7em;\n    fill: var(--theia-titleBar-activeForeground);\n}\n\n.lane>.lane_header {\n    fill: var(--theia-titleBar-activeBackground);\n}\n\n.lane .lane_header text {\n    font-weight: normal;\n    font-size: 0.7em;\n    fill: var(--theia-titleBar-activeForeground);\n}\n\n.lane>.sprotty-node {\n    fill: none;\n}\n\n.lane-divider {\n    cursor: row-resize;\n}\n\n.lane-divider>polyline {\n    stroke: var(--theia-focusBorder);\n    stroke-width: 2;\n    fill: none;\n}\n\n.lane-divider rect {\n    fill: transparent;\n}\n\n.sequenceFlow .default-symbol {\n    stroke-width: 3;\n}\n\n/* BPMN Edges */\n.bpmnedge>.sprotty-label {\n    fill: var(--theia-titleBar-activeForeground);\n    text-align: center;\n}\n\n.sprotty-edge.messageFlow .line {\n    stroke-dasharray: 6, 4;\n}\n\n.sprotty-edge.association .line {\n    stroke-dasharray: 4, 4;\n}\n\n.sprotty-comp {\n    stroke: transparent;\n    fill: transparent;\n}\n\n\n/* Extension Imixs-Workflow (draft) */\n.intermediateCatchEvent.bpmnextension-imixs>circle {\n    fill: #6f8dab;\n    stroke-width: 2px;\n    stroke: #d48729;\n}\n\n.intermediateCatchEvent.bpmnextension-imixs .icon path {\n    stroke-width: 0;\n    fill: #f0f3f8;\n}\n\n.task.bpmnextension-imixs>.sprotty-node {\n    fill: #425C81;\n    stroke-width: 2px;\n    stroke: #d48729;\n}\n\n.task.bpmnextension-imixs .bpmn-text-node text {\n    fill: #f0f3f8;\n    text-anchor: middle;\n}\n\n.task.bpmnextension-imixs .extension text {\n    fill: #f0f3f8;\n    font-size: 7pt;\n    text-anchor: start;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
